document.addEventListener('submit', async function (event) {
  const form = event.target.closest('[data-ajax-add-to-cart]');
  if (!form) return;

  event.preventDefault();

  if (form.dataset.submitted === 'true') return;
  form.dataset.submitted = 'true';

  const button = form.querySelector('button[type="submit"], [type="submit"]');
  const originalText = button ? button.textContent.trim() : '';

  if (button) {
    button.disabled = true;
    button.textContent = 'Aggiungo...';
  }

  try {
    const formData = new FormData(form);

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    if (!addResponse.ok) {
      throw new Error('Errore aggiunta al carrello');
    }

    /* ===============================
       GA4 EVENT — ADD TO CART
    ================================ */
    const addedItem = await addResponse.json();

    const ga4Item = {
      item_id: String(addedItem.product_id || addedItem.id),
      item_variant: String(addedItem.variant_id || addedItem.id),
      item_name: addedItem.product_title || addedItem.title,
      price: (addedItem.final_price || addedItem.price || 0) / 100,
      quantity: addedItem.quantity || 1
    };

    const ga4Payload = {
      currency: 'EUR',
      value: (addedItem.final_line_price || addedItem.line_price || addedItem.price || 0) / 100,
      items: [ga4Item]
    };

    document.dispatchEvent(new CustomEvent('dr:add_to_cart', {
      detail: ga4Payload
    }));
    /* ===============================
       END GA4
    ================================ */

    const cartResponse = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('Errore lettura carrello');
    }

    const cart = await cartResponse.json();

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const drawerContent = document.querySelector('#DrCartDrawerContent');

    if (drawerContent) {
      const drawerResponse = await fetch(window.location.pathname, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!drawerResponse.ok) {
        throw new Error('Errore aggiornamento drawer');
      }

      const drawerHtml = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHtml, 'text/html');

      const newDrawerContent = doc.querySelector('#DrCartDrawerContent');

      if (newDrawerContent) {
        drawerContent.innerHTML = newDrawerContent.innerHTML;

        if (typeof window.initDrCartDrawer === 'function') {
          window.initDrCartDrawer();
        }
      }
    }

    if (typeof window.openDrCartDrawer === 'function') {
      window.openDrCartDrawer();
    }

    if (button) {
      button.textContent = 'Aggiunto';
    }

    setTimeout(() => {
      form.dataset.submitted = 'false';

      if (button) {
        button.disabled = false;
        button.textContent = originalText || 'Aggiungi al carrello';
      }
    }, 1200);

  } catch (error) {
    console.error('DR AJAX CART ERROR:', error);

    if (button) {
      button.disabled = false;
      button.textContent = 'Errore';
    }

    setTimeout(() => {
      form.dataset.submitted = 'false';

      if (button) {
        button.textContent = originalText || 'Aggiungi al carrello';
      }
    }, 1200);
  }
});

document.addEventListener('click', async function (event) {
  const removeButton = event.target.closest('[data-cart-remove]');
  if (!removeButton) return;

  event.preventDefault();

  const line = parseInt(removeButton.dataset.line, 10);
  if (!line) return;

  try {
    removeButton.disabled = true;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error('Errore rimozione prodotto');
    }

    const cart = await response.json();

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const drawerContent = document.querySelector('#DrCartDrawerContent');

    if (drawerContent) {
      const drawerResponse = await fetch(window.location.pathname, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!drawerResponse.ok) {
        throw new Error('Errore aggiornamento drawer');
      }

      const drawerHtml = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHtml, 'text/html');

      const newDrawerContent = doc.querySelector('#DrCartDrawerContent');

      if (newDrawerContent) {
        drawerContent.innerHTML = newDrawerContent.innerHTML;

        if (typeof window.initDrCartDrawer === 'function') {
          window.initDrCartDrawer();
        }
      }
    }

    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    if (typeof window.openDrCartDrawer === 'function') {
      window.openDrCartDrawer();
    }

  } catch (error) {
    console.error('DR AJAX REMOVE ERROR:', error);
    removeButton.disabled = false;
  }
});